import { uniqueId } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import clsx from 'clsx';
import { ContentLinkModel } from '../../Types/ContentLinkModel';

interface MegaMenuProps {
  open: boolean;
  onMegaMenuClose: any;
  link: ContentLinkModel;
  blocks: any;
}

const MegaMenu = ({
  open,
  onMegaMenuClose,
  link,
  blocks,
}: MegaMenuProps) => {
  const dispatch = useDispatch();
  const blockContainerRef = useRef<HTMLDivElement>(null);
  const [id] = useState(uniqueId());

  useEffect(() => {
    if (!blockContainerRef?.current) return;
    blockContainerRef.current.innerHTML = '';
    for (let block of blocks) {
      blockContainerRef.current.appendChild(block);
    }
  }, [blockContainerRef, blocks]);

  useEffect(() => {
    if (open) {
      dispatch(addOverlay('MegaMenu-' + id, onMegaMenuClose));
    } else {
      dispatch(removeOverlay('MegaMenu-' + id));
    }
  }, [open]);
  return (
    <div
      className={clsx(
        'absolute',
        'top-[calc(100%_+_1px)]',
        'left-0',
        'right-0',
        'p-8',
        'flex',
        'justify-center',
        'rounded-b',
        open ? 'opacity-1' : 'opacity-0',
        !open && 'pointer-events-none',
        'bg-white',
        'transition-opacity',
        'ease-in-out',
        'delay-125'
      )}
    >
      <div
        className={clsx('flex w-full max-w-[1888px] justify-center gap-4')}
      >
        {link.links?.length > 0 && (
          <div
            className="flex-row gap-4 pr-8"
            style={{ width: `calc(100%/6 * ${link.links.length})` }}
          >
            {link.titleLinkModel?.text && (
              <div className="h2 mb-5 w-full border-b border-gray-100 pb-4">
                {link.titleLinkModel.href ? (
                  <a
                    className="underlined-link self-start"
                    tabIndex={open ? 0 : -1}
                    href={link.titleLinkModel.href}
                  >
                    {link.titleLinkModel.text}
                  </a>
                ) : (
                  <span>{link.titleLinkModel.text}</span>
                )}
              </div>
            )}
            <div className="flex w-full flex-row gap-4">
              {link.links.map((subLink, idx) => (
                <div
                  key={link.url + subLink.url + 'mega-sub-' + idx}
                  style={{ width: `calc(100%/${link.links.length})` }}
                  className="flex flex-col gap-2"
                >
                  {subLink?.columnHeading?.href ? (
                    <a
                      className="underlined-link h4 self-start"
                      href={subLink.columnHeading?.href}
                      tabIndex={open ? 0 : -1}
                    >
                      {subLink.columnHeading?.text ?? <>&nbsp;</>}
                    </a>
                  ) : (
                    <span className="h4">
                      {subLink.columnHeading?.text ?? <>&nbsp;</>}
                    </span>
                  )}
                  {subLink.links?.length > 0 &&
                    subLink.links.map((subSubLink) => (
                      <a
                        key={
                          subLink.url +
                          subSubLink.url +
                          subLink.name +
                          'mega-sub-2'
                        }
                        className="underlined-link self-start font-garamond text-xl text-gray-500"
                        href={subSubLink.url}
                        tabIndex={open ? 0 : -1}
                        dangerouslySetInnerHTML={{
                          __html: subSubLink.name,
                        }}
                      ></a>
                    ))}
                  {subLink.extraInfo?.value && (
                    <div
                      className="[&_a]:underlined-link [&_a]:mb-2 [&_a]:!inline-block [&_a]:!self-start [&_a]:font-garamond [&_a]:text-xl [&_a]:!leading-normal [&_a]:text-gray-500 [&_p]:!leading-normal"
                      dangerouslySetInnerHTML={{
                        __html: subLink.extraInfo?.value,
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {blocks.length > 0 && (
          <div
            style={{
              width: `calc(100% / 6 * ${blocks.length})`,
              gridTemplateColumns: `repeat(${blocks.length}, 1fr)`,
            }}
            className="grid gap-4"
            ref={blockContainerRef}
          ></div>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;
